import styled from '@emotion/styled';

export const TabsStyled = styled.div`
  background: linear-gradient(90deg, #b48cff 0%, #b1c9fb 50%, #f6f9fc 100%);
`;
